import { useStyles } from "./ShopOwnedInventory.style";
import { LoadMoreObserver, Typography, TypographyVariant } from "@onmo/ui";
import { Inventory, InventoryAvatarData } from "@onmo/graphql/graphql";
import { meGQL } from "../../../graphql";
import ShopAvatar from "../../core/ShopAvatar/ShopAvatar";
import ShopBundle from "../../core/ShopBundle/ShopBundle";
import {
  useFetchBundlesInventory,
  useFetchOwnedInventory,
} from "../../../hooks/resolvers/useShopQuery";
import { useAppDispatch } from "../../../hooks";
import { setOpenBundle } from "../../../slices/shop";
import { useQuery } from "@apollo/client";
import ShopAvatarLoading from "../../core/ShopAvatar/ShopAvatarLoading";
import { useTranslation } from "react-i18next";

const ShopOwnedInventory: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { data: dataMe } = useQuery(meGQL);
  const { ownedInventory, loadMore } = useFetchOwnedInventory();
  const { bundlesInventoryOwned } = useFetchBundlesInventory();

  return (
    <>
      {(!bundlesInventoryOwned || !!bundlesInventoryOwned?.length) && (
        <div className={classes.tabContent}>
          <div className={classes.tabTitle}>
            <Typography variant={TypographyVariant.HeadingH6Bold}>
              {t("bundles_owned")}
            </Typography>
          </div>
          <div className={classes.listBundles}>
            {bundlesInventoryOwned?.map((item: Inventory) => (
              <ShopBundle
                inventory={item}
                fullWidth
                onClick={() => dispatch(setOpenBundle({ openBundle: item }))}
              />
            ))}
          </div>
        </div>
      )}
      {(!ownedInventory || !!ownedInventory?.length) && (
        <div className={classes.tabContent}>
          <div className={classes.tabTitle}>
            <Typography variant={TypographyVariant.HeadingH6Bold}>
              {t("avatars_owned")}
            </Typography>
          </div>
          <div className={classes.listAvatars}>
            {!ownedInventory
              ? Array.from(new Array(5)).map((_, idx) => (
                  <ShopAvatarLoading key={idx} />
                ))
              : ownedInventory?.map((item: Inventory) => {
                  return (
                    <ShopAvatar
                      inventory={item}
                      isUsing={
                        (item?.data as InventoryAvatarData).url ===
                        dataMe?.me.avatar
                      }
                    />
                  );
                })}
            <LoadMoreObserver loadMore={loadMore} />
          </div>
        </div>
      )}
    </>
  );
};
export default ShopOwnedInventory;
